import NotificacaoService from './../_services/index'
import { erroArrayToString } from '@/utils/trataErroRetornoApi'
import notificacaoModel from '../_model/index'

const state = {
  loading: false,
  loadingStore: false,
  notificacoes: [],
  notificacoes_usu: [],
  notificacaoSelecionada: undefined,
  erros: '',
}

const getters = {
  GET_NOTIFICACOES_USU: (state) => state.notificacoes_usu,
  GET_NOTIFICACOES: (state) => state.notificacoes,
  GET_ERROS: state => state.erros,
}

const mutations = {

  SET_LOADING_STORE: (state, ativo) => {
    state.loadingStore = ativo ? ativo : false
  },

  NOTIFICACAO_SELECTED: (state, { notificacao }) => {
    state.notificacaoSelecionada = Object.assign({}, notificacao)
  },

  SET_NOTFICACOES: (state, { notificacoes }) => {
    state.notificacoes = notificacoes
  },

  SET_NOTFICACOES_USU: (state, { notificacoes }) => {
    state.notificacoes_usu = notificacoes
  },

  SET_ERROS: (state, erros) => {
    state.erros = erros.erros
  },

  ERASE_ERROS: (state) => {
    state.erros = ''
  },

  RESET_SELECTED: state => state.notificacaoSelecionada = undefined,

  UPT_NOTIFICACOES_USU: (state, id) => {
    let newArray = state.notificacoes_usu.filter(item => item.id !== id)
    state.notificacoes_usu = JSON.parse(JSON.stringify(newArray))
  }

}

const actions = {

  GET_NOTIFICACOES_USU: ({ commit }) => {
    return new Promise(async (resolve, reject) => {
      commit('SET_NOTFICACOES_USU', { notificacoes: [] })
      await NotificacaoService.getNotificacoesUsuario()
        .then(resp => {
          if (resp.data.status) {
            commit('SET_NOTFICACOES_USU', { notificacoes: resp.data.notificacoes })
            resolve(resp.data)
          } else if (resp.data.erro) {
            commit('SET_ERROS', { erros: resp.data.erro })
            reject(resp.data.erro)
          }
        })
        .catch(error => {
          console.log(error)
          commit('SET_ERROS', { erros: 'Erro ao acessar api' })
          reject(error)
        })
    })
  },

  GET_NOTIFICACOES: ({ commit }, processo_id) => {
    return new Promise(async (resolve, reject) => {
      NotificacaoService.getNotificacoes(processo_id)
        .then(response => {
          if (response.data.status) {
            commit('SET_NOTFICACOES', { notificacoes: response.data.notificacoes })
            resolve()
          } else if (response.data.erro) {
            commit('SET_ERROS', { erros: response.data.erro })
            reject()
          }
        })
        .catch(error => {
          console.log(error)
          commit('SET_ERROS', { erros: 'Erro ao acessar api' })
          reject(error)
        })
    })
  },

  GET_NOTIFICACAO: async ({ commit }, id) => {
    return new Promise(async (resolve, reject) => {
      commit('ERASE_ERROS')
      await NotificacaoService.getNotificacao(id)
        .then(response => {
          if (response.data.status) {
            commit('NOTIFICACAO_SELECTED', { notificacao: response.data.notificacao })
            resolve()
          } else if (response.data.erro) {
            commit('SET_ERROS', { erros: response.data.erro })
            reject()
          }
        })
        .catch(error => {
          console.log(error)
          commit('SET_ERROS', { erros: 'Erro ao acessar api' })
          reject(error)
        })
    })

  },

  STORE_NOTIFICACAO: async ({ commit, dispatch, state }, notificacao) => {
    return new Promise(async (resolve, reject) => {
      commit('ERASE_ERROS')


      try {
        commit('SET_LOADING_STORE', true)
        if (!notificacao.notificacao_id || !(notificacao.notificacao_id > 0)) {
          var response = await NotificacaoService.postNotificacao(notificacao)
        } else {
          var response = await NotificacaoService.putNotificacao(notificacao.notificacao_id, notificacao)
        }

        if (response.data.status) {
          commit('NOTIFICACAO_SELECTED', { notificacao: response.data.notificacao })
          //dispatch('GET_NOTIFICACOES')
          resolve()

        } else if (!response.data.status && response.data.validacao) {
          var erros = erroArrayToString(response.data.erros)
          commit('SET_ERROS', { erros: erros })
          reject()

        } else if (response.data.erro) {
          commit('SET_ERROS', { erros: response.data.erro })
          reject()
        }

      } catch (error) {
        console.log(error)
        commit('SET_ERROS', { erros: 'Erro ao acessar api' })
        reject(error)
      } finally {
        commit('SET_LOADING_STORE', false)
      }
    })
  },

  CONFIRMA_VIZUALIZACAO: ({ commit }, notificacao) => {
    return new Promise(async (resolve, reject) => {
      await NotificacaoService.putConfirmacao(notificacao.nu_id)
        .then(resp => {
          if (resp.data.status) {
            commit('UPT_NOTIFICACOES_USU', notificacao.id)
            resolve(resp.data)
          } else if (response.data.erro) {
            reject(resp.data)
          }
        })
        .catch((e) => {
          reject(e)
        })
    })
  },

  DELETE_NOTIFICACAO: async ({ commit, getters }, notificacao) => {
    return new Promise(async (resolve, reject) => {
      commit('ERASE_ERROS')
      try {
        var response = await NotificacaoService.deleteNotificacao(notificacao.notificacao_id)
        if (response.data.status) {
           var arrayNot = getters.GET_NOTIFICACOES;
          var index = arrayNot.findIndex(item => item.notificacao_id == notificacao.notificacao_id)
          arrayNot.splice(index, 1);
          commit('SET_NOTFICACOES', { notificacoes: arrayNot })
          resolve()

        } else if (response.data.erro) {
          commit('SET_ERROS', { erros: response.data.erro })
          reject()
        }

      } catch (error) {
        console.log(error)
        commit('SET_ERROS', { erros: 'Erro ao acessar api' })
        reject(error)
      }
    })
  },

  NOTIFICACAO_SELECTED: async ({ dispatch, commit }, id) => {
    if (id > 0) {
      await dispatch('GET_NOTIFICACAO', id)
    } else {
      var obj = new notificacaoModel()
      await commit('NOTIFICACAO_SELECTED', { notificacao: obj })
    }
  },

  RESET_SELECTED: ({ commit }) => { commit('RESET_SELECTED') },

}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
}   


// WEBPACK FOOTER //
// ./src/views/Notificacoes/_store/index.js